import { Component, OnInit } from "@angular/core";
import { locale as italian } from "../../../../i18n/it";
import { EducationTitleService } from "../../../../auth/service/education-title.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UtilsService } from "../../../../auth/service/utils.service";
import { AuthenticationService } from "../../../../auth/service";
import { Router } from "@angular/router";
import { IEducationTitle } from "app/auth/models/education";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { IDatatableConfig } from "app/auth/models/datatable";

@Component({
  selector: "app-list-education-title",
  templateUrl: "./list-education-title.component.html",
  styleUrls: ["./list-education-title.component.scss"],
})
export class ListEducationTitleComponent implements OnInit {
  public config: IDatatableConfig;
  public tableLimit: number = 10;
  public searchKeyword: string = "";
  public contentHeader: IContentHeader;
  public newEducationTitle: string = "";
  public currentEducation: IEducationTitle;
  public educations: IEducationTitle[];
  public filteredEducations: IEducationTitle[] = [];
  public showModalError: boolean = false;

  constructor(
    public _educationTitleService: EducationTitleService,
    public _modalService: NgbModal,
    public _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
    public router: Router,
  ) {}

  async ngOnInit() {
    this.contentHeader = {
      headerTitle: italian.data.MENU.EDUCATION_TITLE,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.MENU.MANAGE,
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: italian.data.MENU.EDUCATION_TITLE,
            isLink: false,
          },
        ],
      },
    };
    this.config = {
      searchable: true,
      exportable: true,
      selectLimitItems: true,
      headerHeight: 30,
      rowHeight: 50,
      footerHeight: 60,
      scrollbarH: true,
      columns: [
        {
          value: "name",
          text: italian.data.FIRSTNAME,
          width: 500,
          sortable: true,
        },
        {
          value: "used",
          text: italian.data.NUMBER_EMPOLYEE,
          width: 400,
          sortable: true,
        },
      ],
    };

    if (this._utilService.isMobile) {
      this.config.columns.pop();
      this.config.columns[0].width = null;
      this.config.scrollbarH = false;
      this.config.rowHeight = 90;
    }

    await this.loadEducationTitles();
  }

  async loadEducationTitles() {
    await this._educationTitleService.getList().then((response: IEducationTitle[]) => {
      this.educations = response;
      this.educationTitleList();
    });
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }

  educationTitleList() {
    let items: IEducationTitle[] = this.educations;
    const keywords: string = this.searchKeyword.trim().toLowerCase();

    if (keywords.length > 0) {
      items = this.educations.filter((item: IEducationTitle) => item.name.toLowerCase().includes(this.searchKeyword.trim().toLowerCase()));
    }

    this.filteredEducations = items;
  }

  async deleteEducationTitle(currenEducation) {
    if (!this._authenticationService.hasCapability("delete_education")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += currenEducation.name;
    if (currenEducation.used < 1) {
      await this._utilService.showSWALDeleteConfirmation({ text: deleteText }).then(async (result) => {
        if (result.value) {
          await this._educationTitleService
            .delete(currenEducation.id)
            .then(async () => {
              await this._utilService.showPopupItemDeleted().then(async () => {
                await this.loadEducationTitles();
              });
            })
            .catch(() => this._utilService.showSWALError({ text: "ERROR_EDUCATION_INSERT" }));
        } else if (result.isDismissed) {
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      });
    } else {
      await this._utilService.showSWALError({ text: "USED_EDUCATION_TEXT" });
    }
  }

  async addEducationTitle() {
    if (!this._authenticationService.hasCapability("create_education")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }

    if (!this.newEducationTitle || this.newEducationTitle.length < 1) {
      this.showModalError = true;
      return false;
    }
    this._utilService.showLoading();
    await this._educationTitleService
      .create({ name: this.newEducationTitle })
      .then(() => {
        this.loadEducationTitles();
        this._utilService.hideLoading();
        this._modalService.dismissAll();
        this.newEducationTitle = "";
        this._utilService.showSWALSuccess({ text: "SUCCESS_UPLOAD_EDUCATION" });
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_EDUCATION_REMOVE" });
      });
  }

  async editEducationTitle() {
    if (!this._authenticationService.hasCapability("edit_education")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    if (!this.currentEducation.name || this.currentEducation.name.length < 1) {
      this.showModalError = true;
      return false;
    }
    this._utilService.showLoading();
    this._educationTitleService
      .update(this.currentEducation.id, { name: this.currentEducation.name })
      .then(() => {
        this.loadEducationTitles();
        this._utilService.hideLoading();
        this._modalService.dismissAll();
        this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_EDUCATION" });
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_EDUCATION_EDIT" });
      });
    return this.loadEducationTitles();
  }

  public modalOpen(whichModal, education) {
    this.newEducationTitle = "";
    this._modalService.open(whichModal, {
      size: "sm",
      centered: true,
    });
    this.currentEducation = JSON.parse(JSON.stringify(education));
    this.showModalError = false;
  }
}
